import { createSlice } from '@reduxjs/toolkit';
// utils
// import axios from '../../../utils/axios';
// import parseQueryParams from '../../../utils/query';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  pages: [],
};

const slice = createSlice({
  name: 'FormManager',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // END LOADING
    endLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // SET PAGES
    setPages(state, action) {
      state.pages = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { startLoading, endLoading, setPages } = slice.actions;

// ----------------------------------------------------------------------
